export default "__VITE_ASSET__CKRjuFPC__"